import PropTypes from 'prop-types';
import React from 'react';
import { SuggestedProjectsSection } from '../common/SuggestedProjectsSection.js';

export class ProjectRecommendations extends React.PureComponent {
	constructor(props, context) {
		super(props, context);
	}

	render() {
		if (!this.props.showProjectRecommendations){
			return null;
		}

		return (
				<div id="suggested-projects">
					<section className="projects">
						<div className="container">
							<SuggestedProjectsSection
									projectIdsToExclude={[this.props.proposalId]}
									projectPageProjectId={this.props.proposalId}
									locationSearchCity={this.props.schoolCity}
									locationSearchCounty={this.props.schoolCounty}
									locationSearchState={this.props.schoolState}
									onScrollElementId={this.props.onScrollElementId}
									minProjectsToShow={1}
							/>
						</div>
					</section>
				</div>
		);
	}
}
ProjectRecommendations.propTypes = {
	proposalId: PropTypes.number,
	schoolCity: PropTypes.string,
	schoolCounty: PropTypes.string,
	schoolState: PropTypes.string,
	onScrollElementId: PropTypes.string,
	showProjectRecommendations: PropTypes.bool.isRequired
};
